import SistemaState from './types';
import {ThemeConfig,ThemePresent} from '@/temas';
import Alerta from '@/entidades/Sistema/Alerta';
export const state : SistemaState={
    themeMode:new ThemeConfig(),
    vuetifyPresent: new ThemePresent(),
    loading:false,
    loadingText:"",
    alert: new Alerta()
}